module.exports = __webpack_public_path__ + "img/4-5.643e9bdc.svg";